import { render, staticRenderFns } from "./InTheAssessmentOK.vue?vue&type=template&id=7f202a0f&scoped=true&"
import script from "./InTheAssessmentOK.vue?vue&type=script&lang=js&"
export * from "./InTheAssessmentOK.vue?vue&type=script&lang=js&"
import style0 from "./InTheAssessmentOK.vue?vue&type=style&index=0&id=7f202a0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f202a0f",
  null
  
)

export default component.exports